import { faLock } from "@fortawesome/free-solid-svg-icons";
import {
  defaultGapping,
  defaultLayouts,
  defaultTypography,
  GSButton,
  GSItemList,
  GSSplitView,
} from "golfstatus_react_components";
import CartPaymentMethod from "../events/event/cart/cart-payment-method";
import { useDispatch, useSelector } from "react-redux";
import {
  selectRegistrationCustomer,
  selectRegistrationOrder,
  updateOrderThunk,
} from "../../reducers/registrationOrderSlice";
import { BANK_ACCOUNT, CREDIT_CARD, getActivePaymentMethods } from "../../forms/CartSections";
import { usePermissions } from "../../hooks/permissionHooks";
import { usePaymentOptions } from "../../hooks/tournamentHooks";
import { selectLoggedInUserIsKnownNonAdmin } from "../../reducers/appSlice";

const PaymentSelectWidget = () => {
  const dispatch = useDispatch();
  const canAutoApplySavedPayment = useSelector(selectLoggedInUserIsKnownNonAdmin);

  const registrationOrder = useSelector(selectRegistrationOrder);
  const permissions = usePermissions()
  const {lastCard, lastBank} = usePaymentOptions()

  const registrationCustomer = useSelector(selectRegistrationCustomer)

  const currentPaymentMethod = getActivePaymentMethods(permissions).find?.(
    (m) => m.type === registrationOrder?.paymentType
  );

  const updatePaymentType = (type) => {
    if (registrationOrder?.paymentType === type) {
      return;
    }
    let defaultPayment = null
    if(canAutoApplySavedPayment){
      if(type === BANK_ACCOUNT && lastBank?.id){
        defaultPayment = lastBank
      }
      else if(type === CREDIT_CARD && lastCard?.id){
        defaultPayment = lastCard
      }
    }
    const ru =
      registrationOrder?.donationOrderItems
        ?.filter?.((d) => d?.roundUp)
        ?.map?.((d) => {
          return { round_up: true };
        }) ?? [];
    const don =
      registrationOrder?.donationOrderItems
        ?.filter?.((d) => !d?.roundUp)
        ?.map?.((d) => {
          return { id: d?.id, amount: d?.amount };
        }) ?? [];

    const update = {
      ...registrationOrder,
      paymentType: type,
      globalPaymentToken: null,
      stripePaymentToken: null,
      cardFirstName: null,
      cardLastName: null,
      card: null,
      internationalCardUsed: false,
      paymentOption: defaultPayment,
      donationOrderItems: [...ru, ...don],
      saveCard: false,
      registrationCustomer
    };
    dispatch(updateOrderThunk(update));
  };

  const activePayments = getActivePaymentMethods({...permissions, hasBankAccountAttached: !!lastBank})

  return (
    <GSSplitView
      style={{ ...defaultLayouts.fullWidth }}
      dividerStyle={{ width: 0 }}
      left={
        <div
          style={{
            ...defaultLayouts.vStack.align("flex-start", "center"),
            ...defaultLayouts.fill,
            ...defaultGapping.xLargeGap,
          }}
        >
          <GSButton
            title="Secure Checkout"
            type="white pill secondary"
            buttonIcon={faLock}
          />
          <div style={{
            ...defaultLayouts.vStack.align("flex-start", "center"),
            ...defaultGapping.mediumLargeGap,
          }}>
            <h2 style={{ ...defaultTypography.headline2 }}>
              Let’s Wrap This Up
            </h2>
            <div style={{ ...defaultTypography.bodyRegular, opacity: 0.7 }}>
              Select how you’d like to pay.
            </div>
          </div>
        </div>
      }
      right={
        <GSItemList
          type="inline-grid medium-large-gap"
          style={{ ...defaultLayouts.fullWidth }}
          gridColumns={Math.min(activePayments.length, 2)}
          items={activePayments}
          listItem={(item) => (
            <CartPaymentMethod
              className="hover-outline"
              style={{ ...defaultLayouts.fill }}
              {...item}
              isSelected={item?.id === currentPaymentMethod?.id}
              onClick={() => {
                updatePaymentType(item?.type);
              }}
            />
          )}
        />
      }
    />
  );
};

export default PaymentSelectWidget;
